import type {Theme, Components} from "../..";

type DividerOverrides = Components<Theme>["MuiDivider"];

const overrides: DividerOverrides = {
    styleOverrides: {
        root: ({theme}) => ({
            borderColor: theme.color.divider.default,
        }),
    },
};

export default overrides;
